<template>
  <div class="container-fluid">
    <div class="row dataTable-filters mt-5 mb-5" :class="filterOpenClass">
      <div class="col-md-4 col-lg-4 col-xl-4" v-if="selectedCustomer">
        <div class="dropdown">
          <button class="btn btn-outline-filter dropdown-toggle" type="button">
            <span>{{$t('product.product')}} ({{customFilters[0].options.values.length}})</span>
          </button>
          <div class="dropdown-menu">
            <input class="form-control mb-3" type="text" :placeholder="$t('ui.search')"
                   v-model="searchProduct">
            <div class="option-wrapper">
              <div class="custom-control custom-checkbox"
                   v-for="(product, index) in productBySearch"
                   :key="product+'-'+index">
                <input v-model="customFilters[0].options.values"
                       :value="product.id"
                       type="checkbox"
                       :id="product.id+'-'+index"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="product.id+'-'+index">
                  <span>{{product.name}}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-lg-4 col-xl-4" v-if="selectedCustomer">
        <div class="dropdown">
          <button class="btn btn-outline-filter dropdown-toggle" type="button">
            <span>{{$t('location.location')}} ({{customFilters[1].options.values.length}})</span>
          </button>
          <div class="dropdown-menu">
            <input class="form-control mb-3" type="text" :placeholder="$t('ui.search')"
                   v-model="searchLocation">
            <div class="option-wrapper">
              <div class="custom-control custom-checkbox"
                   v-for="(loc, index) in locationBySearch"
                   :key="loc+'-'+index">
                <input v-model.number="customFilters[1].options.values"
                       :value="loc.id"
                       type="checkbox"
                       :id="loc.id+'-'+index"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="loc.id+'-'+index">
                  <span>{{loc.name}} </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-lg-4 col-xl-4">
        <div class="dropdown">
          <button class="btn btn-outline-filter dropdown-toggle" type="button">
            <span>{{$t('customer.customer')}} ({{selectedCustomer ? 1 : 0}})</span>
          </button>
          <div class="dropdown-menu">
            <input class="form-control mb-3" type="text" :placeholder="$t('ui.search')"
                   v-model="searchCustomer">
            <div class="option-wrapper">
              <div class="custom-control custom-radio"
                   v-for="(customer, index) in   customerBySearch"
                   :key="customer+'-'+index">
                <input v-model="selectedCustomer"
                       :value="customer.name"
                       type="radio"
                       @change="selectedCustomerChanged()"
                       :id="customer.name+'-'+index"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="customer.name+'-'+index">
                  <span>{{customer.name}} </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-12">
        <datatables
                :tableClass="tableClass"
                v-if="selectedCustomer && getProducts.length && renderedComponent"
                :rows="getProducts"
                :columns="getColumns"
                tableID="candidates"
                :tableInitOptions="tableInitOptions"
                :customFilters="customFilters"
                routerLinkClass="dt-router-link"
                deleteClass="delete"
        ></datatables>
      </div>
    </div>
  </div>
</template>


<script>
  import {mapActions, mapGetters, mapMutations} from 'vuex';
  import dataTables from '../../mixins/datatables';


  export default {
    name: 'team-lead-overview',
    components: {},
    mixins: [dataTables],
    data() {
      return {
        filterOpen: false,
        filterOpenClass: 'm-hide-lg',
        searchProduct: '',
        searchLocation: '',
        selectedCustomer: '',
        searchCustomer: '',
        customFilters: [
          {
            filter: 'arrayContains',
            keyToFilter: 'id',
            options: {
              keyToFilter: null,
              values: []
            }
          },
          {
            filter: 'arrayContains',
            keyToFilter: 'locations',
            options: {
              keyToFilter: 'id',
              values: []
            }
          },
          {
            filter: 'arrayContains',
            keyToFilter: 'customer',
            options: {
              keyToFilter: null,
              values: []
            }
          }
        ]
      };
    },
    computed: {
      ...mapGetters('orders',
          ['getOrders', 'getOrder', 'getOrdersFromCargo', 'getCurrentOrderPicking', 'getCurrentProductPicking']),
      ...mapGetters('cargo', ['getCargo']),
      ...mapGetters('locations', ['getLocation', 'getLocations']),
      ...mapGetters(['getAPICompanyID']),
      ...mapGetters('users', ['getMeBasic']),
      ...mapGetters('products', ['getProducts']),
      ...mapGetters('customers', ['getCustomers']),
      getColumns() {
        var self = this;
        return [
          {
            data: 'name', name: this.$t('product.name'), visible: true, searchable: true, responsivePriority: 1
          },
          {
            data: 'productNumber',
            name: this.$t('product.productNumber'),
            visible: true,
            searchable: true,
            responsivePriority: 1
          },
          {
            data: 'customer', name: this.$t('product.customer'), visible: true, searchable: true,
            render: function (data) {
              if(data) {
                return data;
              } else {
                return '';
              }
            }
          },
          {
            data: 'locations',
            name: this.$t('product.location'),
            visible: true,
            searchable: true,
            render: function (locations) {
              return self.renderLocationsStrings(locations);

            }
          },
          {
            data: null,
            name: this.$t('table.options'),
            visible: true,
            searchable: true,
            render: function (data) {
              return '<a class="dt-router-link" data-to="/register-deviation?location=warehouse&locationAdditional=' + data.productNumber + '"><i class="fad fa-exclamation-triangle"></i></a>';
            },
            responsivePriority: 1
          }
        ];

      },
      getUniqueCustomers() {
        let uniqueCustomers = this.getCustomers;
        let allCustomers = [{
          id: 'all-customers',
          name: 'Alle klanten weergeven'
        }];

        return _.concat(allCustomers, _.orderBy(uniqueCustomers, ['name'], ['asc']));
      },
      productBySearch() {
        let products = this.getProducts.filter((search) => {
          return search.name.toLowerCase().indexOf(this.searchProduct.toLowerCase()) >= 0;
        });
        return _.orderBy(products, ['name'], ['asc']);
      },
      locationBySearch() {
        let locations = this.getLocations.filter((search) => {
          return search.name.toLowerCase().indexOf(this.searchLocation.toLowerCase()) >= 0;
        });
        return _.orderBy(locations, ['name'], ['asc']);
      },
      customerBySearch() {
        return this.getUniqueCustomers.filter((search) => {
          return search.name.toLowerCase().indexOf(this.searchCustomer.toLowerCase()) >= 0;
        });
      }
    },
    methods: {
      ...mapMutations('orders', [
        'setCurrentProductPicking'
      ]),
      ...mapActions('orders',
          ['setCurrentOrderPicking']
      ),
      ...mapActions('orderProducts',
          ['checkIfProductIsKnownInOrder',
            'incrementAmountPicked',
            'checkAmountPicked']
      ),
      ...mapActions('loading',
          ['updateScannedProduct']
      ),
      selectedCustomerChanged() {
        this.channelOpened = false;
        if(this.selectedCustomer) {
          this.$store.dispatch('products/closeDBChannel', {clearModule: true}).then(() => {
            if(this.selectedCustomer === 'Alle klanten weergeven') {
              this.$store.dispatch('initDataForPage', ['products']).then(() => {
                this.channelOpened = true;
              });
            } else {
              this.$store.dispatch('initDataForPage', [{
                module: 'products',
                where: ['customer', '==', this.selectedCustomer]
              }]).then(() => {
                this.channelOpened = true;
              });
            }
          });
        }
      },
      renderLocationsStrings(locations) {
        let str = '';
        let length = locations.length;

        if(length !== undefined) {
          locations.forEach((loc, idx) => {
            str += loc.name + ' (' + loc.stock + ')';
            if((length > 1 && idx != 0) || (idx != length - 1)) {
              str += ',';
            }
          });
          return str.split(',').join('<br/>');
          // return str // commented out depending on needs ( could switch with a toggle if needed)
        }
        return '';
      }
    },
    watch: {},
    async beforeRouteLeave(to, from, next) {
      // let resetModules = ['locations', 'customers'];
      if(this.channelOpened) {
        resetModules.push('products');
      }
      await this.$store.dispatch('resetStoreModules', resetModules).catch(console.error);
      next();
    },
    created() {
      this.tableInitOptions.language = {
        searchPlaceholder: this.$t('table.search'),
        sProcessing: this.$t('table.processing'),
        sLengthMenu: '_MENU_',
        sZeroRecords: this.$t('table.noResults'),
        sInfo: this.$t('table.filteredFrom', ['_START_', '_END_', '_TOTAL_']),
        sInfoEmpty: this.$t('table.noResultsDisplay'),
        sInfoFiltered: ' ' + this.$t('table.filteredFrom', ['_MAX_']),
        sInfoPostFix: '',
        sSearch: '',
        sEmptyTable: this.$t('table.noResultsDisplay'),
        sInfoThousands: '.',
        sLoadingRecords: this.$t('table.processing'),
        oPaginate: {
          sFirst: this.$t('table.first'),
          sLast: this.$t('table.last'),
          sNext: this.$t('table.next'),
          sPrevious: this.$t('table.previous')
        },
        oAria: {
          sSortAscending: ': activeer om kolom oplopend te sorteren',
          sSortDescending: ': activeer om kolom aflopend te sorteren'
        }
      };
      // this.$store.dispatch('initDataForPage', ['locations', 'customers']);
    }
  };
</script>


<style lang="scss">
  .dataTable tbody td:last-child {
    text-align: left !important;
  }
</style>



